import actionTypes from './actionTypes';
import type { IGateCondition } from '../sharedTypes';
import type { IInviteRequestPayload, IMutationRequestPayload } from './types';

const actions = {
  inviteRequest: (payload: IInviteRequestPayload) => ({ type: actionTypes.INVITE_REQUEST, payload }),
  inviteSuccess: () => ({ type: actionTypes.INVITE_SUCCESS }),
  inviteGateFailed: (conditions: IGateCondition[]) => ({
    type: actionTypes.INVITE_GATE_FAILED,
    payload: { conditions },
  }),
  inviteError: (message: string) => ({ type: actionTypes.INVITE_ERROR, payload: { message } }),
  removeRequest: (payload: IMutationRequestPayload) => ({ type: actionTypes.REMOVE_REQUEST, payload }),
  removeSuccess: () => ({ type: actionTypes.REMOVE_SUCCESS }),
  removeError: (message: string) => ({ type: actionTypes.REMOVE_ERROR, payload: { message } }),
  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
